import { useState } from "react";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import { Menu as MenuIcon, Close as CloseIcon } from "@mui/icons-material";

import getMenuItems from "./items";
import icons from "./icons";

const styles = {
  root: {
    position: "fixed",
    bottom: 16,
    right: 16,
  },
};

const Mobile = (props) => {
  const { setPrintOpen, me = {}, logout, user, userIsLoading, history } = props;

  const [dialOpen, setDialOpen] = useState(false);

  const menuItems = getMenuItems({
    history,
    logout,
    me,
    user,
    userIsLoading,
    setPrintOpen,
  });

  return (
    <SpeedDial
      sx={styles.root}
      icon={<SpeedDialIcon icon={<MenuIcon />} openIcon={<CloseIcon />} />}
      ariaLabel="Glavni menu"
      open={dialOpen}
      onClick={() => setDialOpen(!dialOpen)}
      color="secondary"
    >
      {menuItems.reverse().map((item) => {
        const { label, icon, onClick, condition = true } = item;
        if (!condition) return null;

        const IconComponent = icons[icon];

        return (
          <SpeedDialAction
            key={`dial-item-${label}`}
            icon={<IconComponent color="primary" fontSize="small" />}
            title={label}
            onClick={() => {
              setDialOpen(false);
              onClick();
            }}
          />
        );
      })}
    </SpeedDial>
  );
};

export default Mobile;
